import axiosFlow from '@/services/axios/axiosFlow'

export default class CategoriasStatusService {
  static async getCategoriasStatus() {
    return axiosFlow.get('categorias-status').then(res => res.data.data)
  }
}
